import { useMemo } from "react";

import { formatChartData, getDomainsData, sortByDomainOrder } from "../../../helpers/helpers";
import useTrafficSearchApiParams from "../../../hooks/useApiParamsSearch";
import { useBrandedSplitData } from "../../../services/search-overview-api/apiHooks";
import type { SearchBrandedSplitDataSchema } from "../../../services/search-overview-api/types";
import type { BrandedSplitData, DomainInfo } from "../../../types";

interface TransformedBrandedTrafficData {
    domain: DomainInfo;
    chartData: BrandedSplitData;
}
const transformBrandedTrafficData = (
    data: SearchBrandedSplitDataSchema,
): { domain: DomainInfo; chartData: BrandedSplitData }[] => {
    if (!data) {
        return [];
    }

    const domainsDataMap = getDomainsData();

    const transformed = Object.entries(data).reduce((acc, [domain, value]) => {
        if (!value) {
            return acc;
        }

        acc.push({
            domain: domainsDataMap[domain],
            chartData: formatChartData(value),
        });

        return acc;
    }, [] as TransformedBrandedTrafficData[]);
    return sortByDomainOrder(transformed, (item) => item.domain.name);
};

const useBrandedTrafficDataTable = () => {
    const { trafficSearchApiParams } = useTrafficSearchApiParams();
    const { data, isLoading, isError } = useBrandedSplitData(trafficSearchApiParams);

    const transformedData = useMemo(() => transformBrandedTrafficData(data), [data]);

    return { data: transformedData, isLoading, isError };
};

export default useBrandedTrafficDataTable;
